import trapFocus from '../../utils/trapFocus';
import { SETTINGS, CLASSES } from '../../utils/constants';

const initCollectionSearchFilters = () => {
  const filtersContainer = document.querySelector('[data-filters-container]');
  if (!filtersContainer) return;

  const filterDrawer = filtersContainer.querySelector('[data-filter-drawer]');
  const openDrawerBtn = filtersContainer.querySelector('[data-open-filter-drawer]');
  const closeDrawerBtn = filtersContainer.querySelector('[data-close-filter-drawer-button]');
  const filterDrawerClearAllBtn = filtersContainer.querySelector('[data-filters-clear-all]');

  const closeFilterDrawer = () => {
    filterDrawer.classList.remove(CLASSES.TRANSLATE_X_0);
    setTimeout(() => {
      filterDrawer.close();
    }, SETTINGS.FILTER_DRAW_ANIMATION_TIME);
  };

  const handleCloseFilterDrawerClick = () => {
    closeFilterDrawer();
  };

  const handleFilterDrawerClick = e => {
    if (!filterDrawer) return;
    const isInDialog = filterDrawer.getBoundingClientRect().right > e.clientX;
    if (!isInDialog) {
      closeFilterDrawer();
    }
  };

  const resetFilterValues = () => {
    const { origin, pathname, search } = window.location;

    if (pathname.includes('/search')) {
      const params = new URLSearchParams(search);
      const q = params.get('q');
      const newUrl = q ? `${origin}${pathname}?q=${encodeURIComponent(q)}` : `${origin}${pathname}`;
      window.location.href = newUrl;
    } else {
      const cleanUrl = origin + pathname;
      window.location.href = cleanUrl;
    }
  };

  const openFilterDrawer = () => {
    filterDrawer.showModal();
    //uses requestAnimationFrame to ensure the class is added after the modal is displayed (on safari)
    //without this, the transition does not work correctly on Safari
    requestAnimationFrame(() => {
      filterDrawer.classList.add(CLASSES.TRANSLATE_X_0);
    });
    trapFocus(filterDrawer);
    filterDrawer.addEventListener('click', handleFilterDrawerClick);
    filterDrawerClearAllBtn.addEventListener('click', resetFilterValues);
    closeDrawerBtn.addEventListener('click', handleCloseFilterDrawerClick);
  };

  openDrawerBtn.addEventListener('click', () => openFilterDrawer());

  filterDrawer.addEventListener('close', () => {
    filterDrawer.removeEventListener('click', handleFilterDrawerClick);
    closeDrawerBtn.removeEventListener('click', handleCloseFilterDrawerClick);
    filterDrawerClearAllBtn.removeEventListener('click', resetFilterValues);
    openDrawerBtn.focus();
  });
};

export default initCollectionSearchFilters;
